import React from 'react';

// Steam-Avatar, wenn wir einen haben -- sonst der Initialen-Kreis aus dem
// Design. Beide belegen exakt denselben Platz.
const Avatar = ({ src, initials, size = 40, font = 14 }) => {
  const base = {
    width: size,
    height: size,
    borderRadius: '50%',
    flex: 'none',
    display: 'grid',
    placeItems: 'center',
  };

  if (src) {
    return <img src={src} alt="" style={{ ...base, objectFit: 'cover' }} />;
  }

  return (
    <div
      style={{
        ...base,
        background: '#e5efdd',
        color: '#3d6b3a',
        fontSize: font,
        fontWeight: 650,
      }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
